import { fetchFromRTM } from './index';
import * as constants from './constants';
import { RTM_ME_GET } from 'containers/ConnectionManager/constants';
import './typedef';

class AccountResolver {
  constructor(connection) {
    this.connection = connection;
  }
  
  /**
   * Fetch a list of annotations for an element
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-annotation-list/)
   * @param {Object} payload
   * @param {List} payload.accountIds
   * @returns {Promise.<[ProjectDTO]>}
   */
  authorAccountList = async ({
    accountIds,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ACCOUNT_SUMMARY_LIST,
      accountIds,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ACCOUNT_SUMMARY_LIST_OK,
      constants.RTM_AUTHOR_ACCOUNT_SUMMARY_LIST_ERROR,
    );
    return response.accountSummaryPayloads;
  };

  getCurrentUser = async () => {
    const responseMsg = await this.connection.fetch(RTM_ME_GET);
    return responseMsg.response.account;
  }

}

export default AccountResolver;
